import script from "./ClientInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientInfo.vue?vue&type=script&setup=true&lang=js"

import "./ClientInfo.vue?vue&type=style&index=0&id=cf8bced0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf8bced0"]])

export default __exports__